module.exports = __webpack_public_path__ + "img/02.0b8a9824.png";